<template>
  <QExpansionItem
    dense
    dense-toggle
    expand-icon="img:https://assets.streem.com.au/icons/expansion-down.svg"
    expand-icon-class="expansion-icon"
    header-class="q-pa-none z-marginals"
    :model-value="open"
  >
    <template #header>
      <slot name="header" />
    </template>

    <slot />
  </QExpansionItem>
</template>

<script setup lang="ts">
defineProps<{
  open?: boolean;
}>();
</script>

<style lang="scss" scoped>
:deep(.q-hoverable:hover) > .q-focus-helper {
  opacity: 0 !important;
}

:deep(.expansion-icon) {
  padding-right: 0;
}
</style>
